import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { CSSProperties } from "react";

export const people = {
  style: {
    marginRight: spacing.sm,
    width: 20,
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const attendeeList = {
  fontSize: 14,
  color: greys.standard,
  flexGrow: 3,
};

export const icon = {
  htmlColor: greys.slate,
};

export const edit = {
  style: {
    right: 0,
    marginTop: -15,
    marginBottom: -15,
  } as CSSProperties,
};

// EDIT MODE
export const editModeContainer: CSSProperties = {
  height: "100%",
  width: "100%",
  position: "absolute",
  overflowY: "scroll",
  zIndex: 2,
  top: 0,
  left: 0,
  backgroundColor: greys.white,
  padding: `${spacing.sm}px 0 ${spacing.sm}px ${spacing.sm}px`,
};

export const title: CSSProperties = {
  color: colors.blueDusk.standard,
  fontWeight: "bold",
  fontSize: 20,
};

export const buttonContainer: CSSProperties = {
  position: "absolute",
  width: "100%",
  bottom: 0,
  zIndex: 1,
  marginLeft: -10,
  padding: "16px 4px 16px 4px",
};
